import React, { useState } from 'react';
import { Copy, Check } from 'lucide-react';
import { CODE_SNIPPETS } from '../code-snippets';

export const SdkPlayground: React.FC = () => {
  const [lang, setLang] = useState<'react' | 'node' | 'ts' | 'curl'>('react');
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = CODE_SNIPPETS[lang];
    const textToCopy = tempDiv.textContent || tempDiv.innerText || '';

    try {
      await navigator.clipboard.writeText(textToCopy);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy', err);
    }
  };

  return (
    <section className="section-dark" id="sdk" style={{ borderTop: '1px solid #374151' }}>
      <div className="container">
        <div className="section-header">
          <div className="eyebrow">Developer Experience</div>
          <h2 className="display-large" style={{ marginTop: 12 }}>
            Integrate identity in three lines of code.
          </h2>
          <p className="body-lg" style={{ maxWidth: 640, marginTop: 12 }}>
            Zero-config TypeScript library with automatic session rotation, Axios interceptors, and complete WebAuthn browser helpers out-of-the-box.
          </p>
        </div>

        <div className="sdk-terminal-container">
          <div className="sdk-tabs-bar">
            <div className="sdk-tab-buttons">
              <button
                type="button"
                className={`sdk-tab-btn ${lang === 'react' ? 'active' : ''}`}
                onClick={() => setLang('react')}
              >
                React / Next.js
              </button>
              <button
                type="button"
                className={`sdk-tab-btn ${lang === 'node' ? 'active' : ''}`}
                onClick={() => setLang('node')}
              >
                Node.js API
              </button>
              <button
                type="button"
                className={`sdk-tab-btn ${lang === 'ts' ? 'active' : ''}`}
                onClick={() => setLang('ts')}
              >
                TypeScript SDK
              </button>
              <button
                type="button"
                className={`sdk-tab-btn ${lang === 'curl' ? 'active' : ''}`}
                onClick={() => setLang('curl')}
              >
                cURL REST
              </button>
            </div>

            <button
              type="button"
              className="sdk-copy-btn"
              onClick={handleCopy}
              title="Copy code to clipboard"
            >
              {copied ? (
                <>
                  <Check size={12} color="#10B981" strokeWidth={3} />
                  <span style={{ color: '#10B981' }}>Copied</span>
                </>
              ) : (
                <>
                  <Copy size={12} strokeWidth={2} />
                  <span>Copy snippet</span>
                </>
              )}
            </button>
          </div>

          <div
            className="sdk-code-display"
            dangerouslySetInnerHTML={{ __html: `<pre><code>${CODE_SNIPPETS[lang]}</code></pre>` }}
          />
        </div>
      </div>
    </section>
  );
};
